<template>
  <span v-if="!cancelled && !itemsMatched">
    <qtm-chip
      color="light-teal"
      text-color="secondary"
      class="text-no-wrap text-capitalize px-2 py-1 ml-2"
      style="font-weight: 400; font-size: 16px"
    >
      <span v-if="loading">
        <v-progress-circular :size="18" :width="2" color="secondary" indeterminate />
        AI-matching...
      </span>
      <span v-else>
        <v-icon icon="mdi-check" />
        AI-matched
      </span>
    </qtm-chip>
    <qtm-btn v-if="loading" color="interactive" tertiary @click="cancel">
      Cancel & Match Manually
    </qtm-btn>
  </span>
</template>

<script setup lang="ts">
import useAutoMatchItems from '@/composables/auto-match-items'

export interface Props {
  items: any[]
  loading?: boolean
  orderItems?: any[]
  multiMatch?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  orderItems: () => [],
})
const emit = defineEmits([
  'update:count',
  'update:items',
  'update:loading'
])

const cancelled = ref(false)
const itemsMatched = ref(false)

const { loading: matching, cancel: cancelMatching, run } = useAutoMatchItems(
  toRef(props, 'items'),
  toRef(props, 'orderItems'),
  {
    multiMatch: toRef(props, 'multiMatch'),
    onItems: items => emit('update:items', items),
    onCount: count => emit('update:count', count),
  }
)

watch(matching, value => emit('update:loading', value))

const cancel = () => {
  cancelled.value = true
  cancelMatching()
}

onMounted(() => {
  itemsMatched.value = props.items.some(item => item.reference_identifier)
  if (!itemsMatched.value) {
    run()
  }
})
</script>
